import { callApi, getEndpoint } from '../../../utils/api';
import { createAction } from 'redux-actions';
import { snakeCase, toUpper } from 'lodash';
import {
  DELETE_AUTO_MAX,
  IAS_DELIVERY_MAIL_CHECK,
  SELECTED_UNIT_ENUM_OBJECT_MAP,
} from '../../../settings/settings';
import { extractValueFromLabelValuePairArray } from '../../../utils/utils';
import { analyticsDataLayer } from '../../utils/analytics-helper';

const AUTOMATIC_UPDATE_RELOAD = 'AUTOMATIC_UPDATE_RELOAD';
const GET_AUTO_MAX = 'GET_AUTO_MAX';
const GET_POA = 'GET_POA';
const GET_SYSTEMATIC_EXCHANGES = 'GET_SYSTEMATIC_EXCHANGES';
const GET_SYSTEMATIC_PURCHASES = 'GET_SYSTEMATIC_PURCHASES';
const GET_SYSTEMATIC_REDEMPTIONS = 'GET_SYSTEMATIC_REDEMPTIONS';
const SELECT_SHOW_MORE_RECURRING_PURCHASES =
  'SELECT_SHOW_MORE_RECURRING_PURCHASES';
const SELECT_SHOW_MORE_RECURRING_REDEMPTIONS =
  'SELECT_SHOW_MORE_RECURRING_REDEMPTIONS';
const SELECT_SHOW_MORE_RECURRING_EXCHANGES =
  'SELECT_SHOW_MORE_RECURRING_EXCHANGES';
const SELECT_SHOW_MORE_RECURRING_RMDS = 'SELECT_SHOW_MORE_RECURRING_RMDS';
const DEFER_RECURRING_TRANSACTION = 'DEFER_RECURRING_TRANSACTION';
export const DEFER_RECURRING_TRANSACTION_FULFILLED =
  'DEFER_RECURRING_TRANSACTION_FULFILLED';
export const DELETE_AUTO_MAX_FULFILLED = 'DELETE_AUTO_MAX_FULFILLED';

export default function automaticInvestments(
  state = {
    autoMaxFailed: false,
    autoMaxLoading: false,
    autoMaxTransactions: null,
    autoMaxPOAs: null,
    autoUpdateReload: false,
    autoUpdateReloadFailed: false,
    error: null,
    RecurringSystematicExchangesShow: false,
    RecurringSystematicPurchasesShow: false,
    RecurringSystematicRedemptionsShow: false,
    RecurringRMDShow: false,
    systematicDeferFailed: false,
    systematicDeferLoading: false,
    systematicDeferSuccess: false,
    systematicExchanges: null,
    systematicExchangesFailed: false,
    systematicExchangesLoading: false,
    systematicPurchases: null,
    systematicPurchasesFailed: false,
    systematicPurchasesLoading: false,
    systematicRedemptions: null,
    systematicRedemptionsFailed: false,
    systematicRedemptionsLoading: false,
    transactions: [],
  },
  { payload, type }
) {
  switch (type) {
    case `${DEFER_RECURRING_TRANSACTION}_PENDING`:
      return {
        ...state,
        systematicDeferLoading: true,
      };
    case `${DEFER_RECURRING_TRANSACTION}_FULFILLED`: {
      const someFailed = payload.body.transactions.some(
        (transaction) => !transaction.success
      );
      const allFailed = payload.body.transactions.every(
        (transaction) => !transaction.success
      );
      return {
        ...state,
        systematicDeferSuccess: true,
        systematicDeferFailed: false,
        systematicDeferLoading: false,
        someFailed: someFailed && !allFailed,
        allFailed: allFailed,
        transactions: payload.body.transactions,
      };
    }
    case `${DEFER_RECURRING_TRANSACTION}_REJECTED`:
      return {
        ...state,
        systematicDeferFailed: true,
        systematicDeferLoading: false,
        error: payload.body,
      };
    case `${GET_SYSTEMATIC_PURCHASES}_PENDING`:
      return {
        ...state,
        systematicPurchasesLoading: true,
      };
    case `${GET_SYSTEMATIC_PURCHASES}_FULFILLED`:
      return {
        ...state,
        autoMaxTransactions: payload.body.autoMaxSystematicActivities,
        systematicPurchases: payload.body.systematicPurchaseActivities,
        systematicPurchasesFailed: false,
        systematicPurchasesLoading: false,
      };
    case `${DELETE_AUTO_MAX}_REJECTED`:
      return {
        ...state,
        autoMaxFailed: true,
        autoMaxLoading: false,
        error: true,
      };
    case `${DELETE_AUTO_MAX}_PENDING`:
      return {
        ...state,
        autoMaxLoading: true,
      };
    case `${DELETE_AUTO_MAX}_FULFILLED`:
      return {
        ...state,
        autoMaxTransactions: payload.body,
        autoMaxFailed: false,
        autoMaxLoading: false,
      };
    case `${GET_SYSTEMATIC_PURCHASES}_REJECTED`:
      return {
        ...state,
        systematicPurchasesFailed: true,
        systematicPurchasesLoading: false,
        error: payload.body,
      };
    case `${GET_SYSTEMATIC_REDEMPTIONS}_PENDING`:
      return {
        ...state,
        systematicRedemptionsLoading: true,
      };
    case `${GET_SYSTEMATIC_REDEMPTIONS}_FULFILLED`:
      return {
        ...state,
        systematicRedemptions: payload.body,
        systematicRedemptionsFailed: false,
        systematicRedemptionsLoading: false,
      };
    case `${GET_SYSTEMATIC_REDEMPTIONS}_REJECTED`:
      return {
        ...state,
        systematicRedemptionsFailed: true,
        systematicRedemptionsLoading: false,
        error: payload.body,
      };
    case `${GET_SYSTEMATIC_EXCHANGES}_PENDING`:
      return {
        ...state,
        systematicExchangesLoading: true,
      };
    case `${GET_SYSTEMATIC_EXCHANGES}_FULFILLED`:
      return {
        ...state,
        systematicExchanges: payload.body,
        systematicExchangesFailed: false,
        systematicExchangesLoading: false,
      };
    case `${GET_SYSTEMATIC_EXCHANGES}_REJECTED`:
      return {
        ...state,
        systematicExchangesFailed: true,
        systematicExchangesLoading: false,
        error: payload.body,
      };
    case `${GET_AUTO_MAX}_PENDING`:
      return {
        ...state,
        autoMaxLoading: true,
        autoMaxFailed: false,
      };
    case `${GET_AUTO_MAX}_FULFILLED`:
      return {
        ...state,
        autoMaxTransactions: payload.body,
        autoMaxLoading: false,
        autoMaxFailed: false,
      };
    case `${GET_AUTO_MAX}_REJECTED`:
      return {
        ...state,
        autoMaxLoading: false,
        autoMaxFailed: true,
      };
    case `${GET_POA}_PENDING`:
      return {
        ...state,
        autoMaxLoading: true,
        autoMaxFailed: false,
      };
    case `${GET_POA}_FULFILLED`:
      return {
        ...state,
        autoMaxPOAs: payload.body,
        autoMaxLoading: false,
        autoMaxFailed: false,
      };
    case `${GET_POA}_REJECTED`:
      return {
        ...state,
        autoMaxLoading: false,
        autoMaxFailed: true,
      };
    case `${SELECT_SHOW_MORE_RECURRING_PURCHASES}_FULFILLED`:
      return {
        ...state,
        RecurringSystematicPurchasesShow: payload,
      };
    case `${SELECT_SHOW_MORE_RECURRING_REDEMPTIONS}_FULFILLED`:
      return {
        ...state,
        RecurringSystematicRedemptionsShow: payload,
      };
    case `${SELECT_SHOW_MORE_RECURRING_EXCHANGES}_FULFILLED`:
      return {
        ...state,
        RecurringSystematicExchangesShow: payload,
      };
    case `${SELECT_SHOW_MORE_RECURRING_RMDS}_FULFILLED`:
      return {
        ...state,
        RecurringRMDShow: payload,
      };
    case `${AUTOMATIC_UPDATE_RELOAD}_PENDING`:
      return {
        ...state,
        autoUpdateReload: true,
        autoUpdateReloadFailed: false,
      };
    case `${AUTOMATIC_UPDATE_RELOAD}_FULFILLED`:
      return {
        ...state,
        autoUpdateReload: false,
        autoUpdateReloadFailed: false,
      };
    case `${AUTOMATIC_UPDATE_RELOAD}_REJECTED`:
      return {
        ...state,
        autoUpdateReload: false,
        autoUpdateReloadFailed: true,
      };
    default:
      return state;
  }
}

export const getSystematicPurchases = () => {
  const payload = callApi(`${getEndpoint('recurringBuyAutomax')}`);
  const type = GET_SYSTEMATIC_PURCHASES;
  return {
    type,
    payload,
  };
};

export const showMoreRecurringPurchases = (show) => {
  return (dispatch) => {
    const action = createAction(
      `${SELECT_SHOW_MORE_RECURRING_PURCHASES}_FULFILLED`
    )(show);
    dispatch(action);
  };
};

export const getSystematicRedemptions = () => {
  const payload = callApi(`${getEndpoint('recurring')}?transactionType=Redeem`);
  const type = GET_SYSTEMATIC_REDEMPTIONS;
  return {
    type,
    payload,
  };
};

export const showMoreRecurringRedemptions = (show) => {
  return (dispatch) => {
    const action = createAction(
      `${SELECT_SHOW_MORE_RECURRING_REDEMPTIONS}_FULFILLED`
    )(show);
    dispatch(action);
  };
};

export const getSystematicExchanges = () => {
  const payload = callApi(
    `${getEndpoint('recurring')}?transactionType=Exchange`
  );
  const type = GET_SYSTEMATIC_EXCHANGES;
  return {
    type,
    payload,
  };
};

export const showMoreAutoExchanges = (show) => {
  return (dispatch) => {
    const action = createAction(
      `${SELECT_SHOW_MORE_RECURRING_EXCHANGES}_FULFILLED`
    )(show);
    dispatch(action);
  };
};

export const showMoreRMDs = (show) => {
  return (dispatch) => {
    const action = createAction(`${SELECT_SHOW_MORE_RECURRING_RMDS}_FULFILLED`)(
      show
    );
    dispatch(action);
  };
};

export const getAutoMaxTransactions = () => {
  const payload = callApi(getEndpoint('iraAutoMax'));
  const type = GET_AUTO_MAX;
  return {
    type,
    payload,
  };
};

export const getAutoMaxPOAs = () => {
  const payload = callApi(getEndpoint('autoMaxPOA'));
  const type = GET_POA;
  return {
    type,
    payload,
  };
};

export const setAutoUpdateLoading = () => {
  const action = createAction(`${AUTOMATIC_UPDATE_RELOAD}_PENDING`)(true);
  return (dispatch) => {
    dispatch(action);
  };
};

export const clearAARCacheAgreements = () => {
  const action = createAction('CLEAR_AAR_CACHE')(
    callApi(getEndpoint('aarCacheClearAgreements'), { method: 'POST' }, true)
  );
  return (dispatch) => {
    dispatch(action);
  };
};

export const updateSystematicTransaction = (
  fund,
  months,
  action,
  type,
  bank = null,
  skipStatus = 'NONE'
) => {
  try {
    analyticsDataLayer({
      accountTypes: toUpper(snakeCase(fund.productType)),
      amount: fund.currentYearAmount,
      quantity: 1,
    });
  } catch (e) {
    // don't let analytics errors cause other things to fail
  }
  let deferInfo = {};
  let selectedTransferDaysArray;
  let selectedTransferMonthsArray;
  if (type !== 'AUTO_MAX') {
    selectedTransferDaysArray =
      typeof fund.transferDays[0] === 'object'
        ? extractValueFromLabelValuePairArray(fund.transferDays)
        : fund.transferDays;
    selectedTransferMonthsArray =
      typeof fund.transferMonths[0] === 'object'
        ? extractValueFromLabelValuePairArray(fund.transferMonths)
        : fund.transferMonths;
  }
  const unitTemp =
    fund?.currentYearAmountUnit?.toUpperCase() === 'DOLLARS'
      ? 'DOLLAR'
      : fund?.currentYearAmountUnit?.toUpperCase();
  switch (type) {
    case 'PURCHASE': {
      deferInfo = {
        bankDto: {
          bankAgreementID: bank
            ? bank.bankAgreementID
            : fund.bank[0].bankAgreementID,
          sameDayBank: bank ? bank.sameDayBank : fund.bank[0].sameDayBank,
        },
        systematicTransactions: [
          {
            amount: fund.currentYearAmount,
            agreementId: fund.agreementID,
            systematicActivitySchedule: {
              investedEveryMonth: fund.investedEveryMonth,
              transferDays: selectedTransferDaysArray,
              transferMonths: selectedTransferMonthsArray,
              deferMonths: months,
              contributionYear: {
                enumerationID: 100,
                enumerationName: 'current',
              },
            },
            systematicTransactionStatus: action,
            systematicTransactionType: type,
            electionAgreementUniqueId1: fund.electionAgreementUniqueId1,
            electionAgreementUniqueId2: fund.electionAgreementUniqueId2,
          },
        ],
        skipStatus,
      };
      break;
    }
    case 'REDEEM': {
      if (fund.deliveryType.enumerationName === IAS_DELIVERY_MAIL_CHECK) {
        deferInfo = {
          systematicTransactions: [
            {
              amount: fund.currentYearAmount,
              agreementId: fund.agreementID,
              systematicActivitySchedule: {
                investedEveryMonth: fund.investedEveryMonth,
                transferDays: selectedTransferDaysArray,
                transferMonths: selectedTransferMonthsArray,
                deferMonths: months,
              },
              disbursementType: SELECTED_UNIT_ENUM_OBJECT_MAP[unitTemp],
              deliveryType: fund.deliveryType,
              fiduciaryRedemptionType: fund.fiduciaryRedemptionType,
              redemptionType: fund.redemptionType,
              irawithholding: fund.IRAWithholding,
              systematicTransactionStatus: action,
              systematicTransactionType: type,
              electionAgreementUniqueId1: fund.electionAgreementUniqueId1,
              electionAgreementUniqueId2: fund.electionAgreementUniqueId2,
            },
          ],
          skipStatus: skipStatus,
        };
      } else {
        deferInfo = {
          bankDto: {
            bankAgreementID: fund.bank[0].bankAgreementID,
            sameDayBank: fund.bank[0].sameDayBank,
          },
          systematicTransactions: [
            {
              amount: fund.currentYearAmount,
              agreementId: fund.agreementID,
              systematicActivitySchedule: {
                investedEveryMonth: fund.investedEveryMonth,
                transferDays: selectedTransferDaysArray,
                transferMonths: selectedTransferMonthsArray,
                deferMonths: months,
              },
              disbursementType: SELECTED_UNIT_ENUM_OBJECT_MAP[unitTemp],
              deliveryType: fund.deliveryType,
              fiduciaryRedemptionType: fund.fiduciaryRedemptionType,
              redemptionType: fund.redemptionType,
              irawithholding: fund.IRAWithholding,
              systematicTransactionStatus: action,
              systematicTransactionType: type,
              electionAgreementUniqueId1: fund.electionAgreementUniqueId1,
              electionAgreementUniqueId2: fund.electionAgreementUniqueId2,
            },
          ],
          skipStatus: skipStatus,
        };
      }
      break;
    }
    case 'EXCHANGE': {
      deferInfo = {
        systematicTransactions: [
          {
            amount: fund.currentYearAmount,
            agreementId: fund.toFund.agreementID,
            sourceAgreementId: fund.sourceAgreementKey.agreementID,
            systematicActivitySchedule: {
              investedEveryMonth: fund.investedEveryMonth,
              transferDays: selectedTransferDaysArray,
              transferMonths: selectedTransferMonthsArray,
              deferMonths: months,
            },
            disbursementType: SELECTED_UNIT_ENUM_OBJECT_MAP[unitTemp],
            systematicTransactionStatus: action,
            systematicTransactionType: type,
            electionAgreementUniqueId1: fund.electionAgreementUniqueId1,
            electionAgreementUniqueId2: fund.electionAgreementUniqueId2,
          },
        ],
        skipInfo: skipStatus,
      };
      break;
    }
    default: {
    }
  }
  return () => {
    if (type === 'AUTO_MAX') {
      const action = createAction(DELETE_AUTO_MAX)(
        callApi(getEndpoint('iraAutoMaxDelete'), { method: 'DELETE' })
      );
      return action;
    } else {
      const action = createAction(DEFER_RECURRING_TRANSACTION)(
        callApi(getEndpoint('recurringPurchase'), { method: 'POST' }, deferInfo)
      );
      return action;
    }
  };
};
